/**
 * @generated SignedSource<<7f40d79bf1c859b7f62ff5419a83ff8d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteProctorMutation$variables = {
  id: string;
};
export type DeleteProctorMutation$data = {
  readonly deleteProctor: {
    readonly id: string;
  };
};
export type DeleteProctorMutation = {
  response: DeleteProctorMutation$data;
  variables: DeleteProctorMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteProctorMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Proctor",
        "kind": "LinkedField",
        "name": "deleteProctor",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteProctorMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Proctor",
        "kind": "LinkedField",
        "name": "deleteProctor",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "babb977a55dbff7764bf4024fba641b8",
    "id": null,
    "metadata": {},
    "name": "DeleteProctorMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteProctorMutation(\n  $id: ID!\n) {\n  deleteProctor(id: $id) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "6b7bdb012abcf69491defc74818e5ebf";

export default node;
